'use client';
/**
 * @todo tag manager
 * @todo captcha
 * @todo anchor
 * @todo logged in
 */
import * as React from 'react';

// import { GlobalContext } from '../GlobalProvider/';
import styled from 'styled-components';

import { FeedbackFormContextProvider } from './Form/FeedbackFormProvider';
import FormFirstStep from './Form/index';
import { PostType } from './types';
// import Anchor from '@/ui/components/Anchor';

export const FeedbackWrapper = styled.div`
  /* display: flex; */
  /* justify-content: end; */
`;

// export const Placeholder = styled.div`
//   display: inline-block;
//   width: 275px;
//   height: auto;

//   @media screen and (max-width: 1020px) {
//     display: none;
//   }
// `;

interface FeedbackFormProps {
  entityId: number;
  entityType: PostType;
}

export default function FeedbackForm({ entityId, entityType }: FeedbackFormProps) {
  return (
    // <Anchor id="feedback_form">
    <FeedbackWrapper>
      <FeedbackFormContextProvider entityId={entityId} entityType={entityType}>
        <FormFirstStep entityType={entityType} />
      </FeedbackFormContextProvider>
    </FeedbackWrapper>
    // </Anchor>
  );
}

// const currentPathname = usePathname();

// const openNotice = React.useCallback(() => {
//   if (isNoticeOpen === true) return null;
//   setIsNoticeOpen(true);
// }, [isNoticeOpen]);

// const closeNotice = React.useCallback(() => {
//   if (isNoticeOpen === false) return null;
//   setIsNoticeOpen(false);
// }, [isNoticeOpen]);

// const setCurrentLocation = React.useCallback(() => {
//   setLoc(`${currentPathname}#feedback_form`);
// }, [currentPathname]);

// if (!isLoggedIn) return (
//   <FormWrapper
//     unfolded={false}
//     onMouseLeave={closeNotice}
//   >
//     <IntlText index={messages[entityType]} />

//     <Thumbs
//       onMouseEnter={openNotice}
//       disabled
//     >
//       <Thumb>
//         <ThumbsUpIcon />
//       </Thumb>
//       <Thumb>
//         <ThumbsDownIcon />
//       </Thumb>
//     </Thumbs>

//     <Notice
//       open={isNoticeOpen}
//     >
//       <IntlText
//         index={messages.notice}
//         components={{
//           link: (
//             <a
//               href={process.env.NEXT_PUBLIC_LOGIN_URL}
//               onClick={setCurrentLocation}
//             />
//           ),
//         }}
//       />
//     </Notice>
//   </FormWrapper>
// );
